import { gql, useLazyQuery } from '@apollo/client';

const GET_USER_MENUS = gql`
  query getUserMenus($params: GetUserMenusArgs!) {
    getUserMenus(getUserMenusArgs: $params) {
      message
      status
      statusCode
      error
      data {
        rolePermissions
        mainMenus {
          id
          name
          label
          path
          componentType
          routes
          icon
          order
          permissions {
            permission
            isRequired
          }
          children {
            id
            name
            label
            path
            componentType
            routes
            icon
            order
          }
        }
      }
    }
  }
`;

export const useGetMenus = () => {
  const [getUserMenus, { data, error, loading }] = useLazyQuery(GET_USER_MENUS);

  return {
    getUserMenus,
    data,
    error,
    loading,
  };
};
